import React, { useState, useEffect } from "react";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import SearchAndFilter from "../../../components/Search/SearchAndFilter";
import Pagination from "../../../components/Footer/Pagination";
import {
  getData,
  getDataWithComp,
  formatCurrency,
  parseCurrency,
  getViewAp,
} from "../../../../utils/SamuiUtils";
import { getReport } from "../../../../utils/ReportUtils";
// import { formatDate } from "../../../../utils/DateUtils";
import WtaxModal from "../../../components/Modal/WtaxModal";
import {
  useDataTableKeyboardNavigation,
  getDataTableRowStyle,
  getDataTableKeyboardInstructions
} from '../../../../utils/DataTableKeyboardNavigation';

import { payMasterModel } from "../../../../model/Purchase/PayMasterModel";

const Main = ({ name, dataMasterList, onPageInsert, onPageUpdate, onRefresh }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [docNo, setDocNo] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(
    localStorage.getItem('currentPage') ? parseInt(localStorage.getItem('currentPage')) : 1
  );
  const [itemsPerPage, setItemsPerPage] = useState(
    localStorage.getItem('itemsPerPageDropdown') ? parseInt(localStorage.getItem('itemsPerPageDropdown')) : 10
  );

  // Search and filter states
  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem('searchTerm') || ''
  );
  const [filteredItems, setFilteredItems] = useState([]);

  // Date filter states - default 2 ปีย้อนหลังถึงปลายเดือน (ให้เห็นข้อมูลปีนี้และปีที่แล้ว)
  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem('startDate');
    return storedStartDate || moment().subtract(2, 'years').startOf('year').format('YYYY-MM-DD');
  });

  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem('endDate');
    return storedEndDate || moment().add(1, 'year').endOf('year').format('YYYY-MM-DD');
  });

  // วันที่ออก จาก API_1701_WTAX_H (ใช้ WTAX_Created_Date, รองรับหลาย casing)
  const getIssueDate = (item) =>
    item?.WTAX_Created_Date ?? item?.WTax_Created_Date ?? item?.Wtax_Created_Date ?? null;

  // DataTable keyboard navigation state
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  const [optimisticPrinted, setOptimisticPrinted] = useState(new Set());

  // Initialize data
  useEffect(() => {
    if (dataMasterList && dataMasterList.length > 0) {
      setCurrentPage(1);
      filterItems();
    } else {
      setFilteredItems([]);
    }
  }, [dataMasterList]);

  // Filter when search term or dates change
  useEffect(() => {
    setCurrentPage(1);
    filterItems();
    localStorage.setItem('searchTerm', searchTerm);
    localStorage.setItem('startDate', startDate);
    localStorage.setItem('endDate', endDate);
  }, [searchTerm, startDate, endDate, dataMasterList]);

  // Filter items function
  const filterItems = () => {
    try {
      let filtered = [...dataMasterList];

      // Date filtering (optional) - ถ้าต้องการกรองตามวันที่ เปิดใช้ block นี้
      const start = moment(startDate, 'YYYY-MM-DD').startOf('day');
      const end = moment(endDate, 'YYYY-MM-DD').endOf('day');
      const useDateFilter = true;
      if (useDateFilter) {
        filtered = filtered.filter((item) => {
          const dateVal = getIssueDate(item);
          if (!dateVal) return true;
          const itemDate = moment.utc(dateVal).isValid() ? moment.utc(dateVal) : moment(dateVal);
          if (!itemDate.isValid()) return true;
          const itemDateStr = itemDate.format('YYYY-MM-DD');
          return itemDateStr >= startDate && itemDateStr <= endDate;
        });
      }

      // Search filtering
      if (searchTerm.trim() !== '') {
        const lowercasedSearchTerm = searchTerm.toLowerCase();
        filtered = filtered.filter((item) =>
          (item.WTAX_No && item.WTAX_No.toLowerCase().includes(lowercasedSearchTerm)) ||
          (item.AP_Name && item.AP_Name.toLowerCase().includes(lowercasedSearchTerm)) ||
          (item.Ref_Doc && item.Ref_Doc.toLowerCase().includes(lowercasedSearchTerm))
        );
      }

      // เรียงตามวันที่ มากไปน้อย (ใหม่ไปเก่า)
      filtered.sort((a, b) => {
        const dateA = getIssueDate(a);
        const dateB = getIssueDate(b);
        if (!dateA) return 1;
        if (!dateB) return -1;
        const mA = moment.utc(dateA).isValid() ? moment.utc(dateA) : moment(dateA);
        const mB = moment.utc(dateB).isValid() ? moment.utc(dateB) : moment(dateB);
        if (!mA.isValid()) return 1;
        if (!mB.isValid()) return -1;
        return mB.valueOf() - mA.valueOf();
      });

      setFilteredItems(filtered);
    } catch (error) {
      console.error('Filter error:', error.message);
      setFilteredItems([]);
    }
  };

  // Pagination calculations
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSelectedRowIndex(0);
    localStorage.setItem('currentPage', pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const [searchItemTerm, setSearchItemTerm] = useState("");
  const [showWTModal, setShowWTModal] = useState(false);
  const handleWTClose = () => setShowWTModal(false);
  const [apDataList, setApDataList] = useState([]);
  const [totalWT, setTotalWT] = useState(0);
  const [inputValueTotalWT, setInputValueTotalWT] = useState("0.00");
  const [selectedOption, setSelectedOption] = useState(1);
  const currentDate = moment().add(543, "years").format("DD/MM/YYYY");
  const [taxData, setTaxData] = useState([
    {
      id: 1,
      type: 5,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
    {
      id: 2,
      type: 6,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
  ]);
  const [taxtotalAmount, setTaxtotalAmount] = useState(0);
  const [formMasterList, setFormMasterList] = useState([payMasterModel()]);
  const [docRef, setDocRef] = useState("");
  const [Ref_PAY_ID, setRef_PAY_ID] = useState();
  const [mode, setMode] = useState("I");

  // Fetch AR Names
  useEffect(() => {
    const fetch = async () => {
      // const arMap = {};
      // for (const item of dataMasterList) {
      //   if (item?.WT_AR_Id && !arMap[item.WT_AR_Id]) {
      //     const result = await getData(
      //       "Tb_Set_AR",
      //       `AR_Id = ${item?.WT_AR_Id}`
      //     );
      //     arMap[item?.WT_AR_Id] = result.at(0).AR_Name || "Unknown";
      //   }
      // }
      // setArNameMap(arMap);
      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
        // setRef_PAY_ID(maxPayNo);
        // setDocRef(maxPayNo);
      }
    };

    if (dataMasterList?.length > 0) {
      fetch();
    }
  }, [dataMasterList]);

  const onRowSelected = async (fromData, index = -1) => {
    // ถ้า fromData เป็น string (จาก keyboard navigation) ให้หา object จาก currentItems
    let selectedData;
    if (typeof fromData === 'string' || typeof fromData === 'number') {
      // หาข้อมูลจาก WTAX_Id
      selectedData = currentItems.find(item => item.WTAX_Id === fromData);
      if (selectedData) {
        // หา index ของข้อมูลนั้น
        const foundIndex = currentItems.findIndex(item => item.WTAX_Id === fromData);
        setSelectedRowIndex(foundIndex);
      }
    } else {
      // fromData เป็น object แล้ว (จาก mouse click)
      selectedData = fromData;
      setSelectedRowIndex(index);
    }

    if (selectedData) {
      setDocNo(selectedData.WTAX_No);
    }
  };

  // Function for print/report (P key)
  const handlePrintReport = (wtaxId) => {
    try {
      getReport("TAX", wtaxId);
    } catch (error) {
      console.error('Error in getReport:', error);
    }
  };

  // Field mappings for keyboard navigation
  const fieldMappings = {
    no: 'WTAX_Id' // เปลี่ยนจาก id เป็น no เพื่อให้ตรงกับ keyboard navigation utility
  };

  // Keyboard navigation
  useDataTableKeyboardNavigation(
    true, // isActive
    currentItems,
    selectedRowIndex,
    setSelectedRowIndex,
    onRowSelected,
    fieldMappings,
    currentPage,
    handlePageChange,
    filteredItems.length,
    itemsPerPage,
    handlePrintReport, // เพิ่ม function สำหรับ P key
    {
      customKeyHandlers: {
        'Enter': (event, context) => {
          event.preventDefault();
          if (currentItems[selectedRowIndex]) {
            // เรียก update function เพื่อไปหน้าแก้ไข
            update(currentItems[selectedRowIndex].WTAX_No);
          }
        },
        'p': (event, context) => {
          event.preventDefault();
          if (currentItems[selectedRowIndex]) {
            handlePrintReport(currentItems[selectedRowIndex].WTAX_Id);
          }
        },
        'P': (event, context) => {
          event.preventDefault();
          if (currentItems[selectedRowIndex]) {
            handlePrintReport(currentItems[selectedRowIndex].WTAX_Id);
          }
        }
      }
    }
  );

  // แสดงวันที่ออก จาก API_1701_WTAX_H เป็น พ.ศ.
  const getIssueDateDisplay = (item) => {
    const dateVal = getIssueDate(item);
    if (!dateVal) return "-";
    const m = moment.utc(dateVal).isValid() ? moment.utc(dateVal) : moment(dateVal);
    return m.isValid() ? m.add(543, "years").format("DD/MM/YYYY") : "-";
  };

  const Type = (type) => {
    switch (type) {
      case 1:
        return "ภ.ง.ด.1ก.";
      case 2:
        return "ภ.ง.ด.1ก.พิเศษ";
      case 3:
        return "ภ.ง.ด.2";
      case 4:
        return "ภ.ง.ด.3";
      case 5:
        return "ภ.ง.ด.2ก.";
      case 6:
        return "ภ.ง.ด.3ก.";
      case 7:
        return "ภ.ง.ด.53";
      default:
        return "ไม่พบข้อมูล";
    }
  };

  // const filteredItemData = dataMasterList?.filter((data) => {
  //   return data?.WTAX_Id.toLowerCase().includes(searchItemTerm.toLowerCase());
  // });

  const Insert = () => {
    setMode("I");
    setFormMasterList([payMasterModel()]);
    setDocRef("");
    const currentDate = moment().add(543, "years").format("DD/MM/YYYY");
    setTaxData([
      {
        id: 1,
        type: 5,
        percent: 3.0,
        date: currentDate,
        amount: 0.0,
        tax: 0.0,
        remark: "",
      },
      {
        id: 2,
        type: 6,
        percent: 3.0,
        date: currentDate,
        amount: 0.0,
        tax: 0.0,
        remark: "",
      },
    ]);
    setSelectedOption(3);
    setShowWTModal(true);
  };

  const update = async (data) => {
    try {
      const tax = await getDataWithComp(
        "API_1701_WTAX_H",
        `and WTAX_No = '${data}'`
      );

      const taxD = await getDataWithComp(
        "API_1702_WTAX_D",
        `and WTAX_No = '${data}'`
      );

      if (!tax || tax.length === 0) {
        console.warn("ไม่พบข้อมูล WTAX");
        return;
      }

      const taxItem = tax[0] || {};
      const taxItemD = taxD[0] || {}; // ป้องกัน undefined

      setDocRef(taxItem?.Ref_Doc);
      setRef_PAY_ID(taxItem?.Ref_Doc?.startsWith("PAY") ? taxItem?.Ref_Doc : null);

      setFormMasterList((prevState) => ({
        ...prevState, // ใช้ค่าเดิมของ state
        payId: taxItem?.Pay_Id,
        apID: taxItem?.AP_Id,
        apCode: taxItem?.AP_Code,
        apName: taxItem?.AP_Name,
        apAdd1: taxItem?.AP_Add1,
        apAdd2: taxItem?.AP_Add2,
        apAdd3: taxItem?.AP_Add3,
        apProvince: taxItem?.AP_Province,
        apZipcode: taxItem?.AP_Zipcode,
        apTaxNo: taxItem?.AP_TaxNo,
      }));

      // ตรวจสอบว่า WTAX_Date มีค่าหรือไม่ก่อนใช้ moment()
      const formattedDate = taxItemD?.WTAX_Date
        ? moment.utc(taxItemD.WTAX_Date).format("DD/MM/YYYY")
        : "";
      console.debug("taxD", taxItem, taxItemD);
      setTaxData([
        {
          id: 1,
          type: taxItemD?.WTAX_TypeNo || "",
          percent: taxItemD?.WTAX_Percent || 0,
          date: formattedDate, // ใช้ค่าที่ตรวจสอบแล้ว
          amount: taxItemD?.WTAX_Total || 0,
          tax: taxItemD?.WTAX_Total_Tax || 0,
          remark: taxItemD?.WTAX_Desc || "",
          Wtax_Id: taxItem?.WTAX_Id || "",
          Wtax_No: taxItem?.WTAX_No || "",
        },
      ]);
      setSelectedOption(taxItem.WTAX_Type || 1);
      setMode("U");
      setShowWTModal(true);
    } catch (error) {
      console.error("เกิดข้อผิดพลาดในการโหลดข้อมูลภาษี:", error);
    }
  };

  return (
    <>
      <Breadcrumbs
        page={name}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/tax" },
        ]}
      />
      <div
        className="container-fluid card py-3 hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        {/* Search and Filter Section */}
        <SearchAndFilter
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchPlaceholder="ค้นหาเลขเอกสาร, ผู้ถูกหักภาษี, เอกสารอ้างอิง..."
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          showDateFilter={true}
          onAddNew={Insert}
          addButtonText={`สร้าง${name}`}
          showAddButton={true}
        />
        <WtaxModal
          showWTModal={showWTModal}
          handleWTClose={handleWTClose}
          apDataList={apDataList}
          setTotalWT={setTotalWT}
          setInputValueTotalWT={setInputValueTotalWT}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          taxData={taxData}
          setTaxData={setTaxData}
          setTaxtotalAmount={setTaxtotalAmount}
          formMasterList={formMasterList}
          setFormMasterList={setFormMasterList}
          docRef={docRef}
          setDocRef={setDocRef}
          Ref_PAY_ID={Ref_PAY_ID}
          setRef_PAY_ID={setRef_PAY_ID}
          mode={mode}
          onSaved={() => {
            if (typeof onRefresh === "function") {
              onRefresh();
            }
          }}
        />
        <hr />
        <div className="row">
          <div className=" mb-1" style={{ borderRight: "2px solid #c7c8c9" }}>
            <div
              className="table-responsive"
              style={{ maxHeight: "650px", overflowY: "auto" }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "3%" }}>
                      #
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      เลขที่เอกสาร
                    </th>
                    <th className="text-center" style={{ width: "30%" }}>
                      ผู้ถูกหักภาษี ณ ที่จ่าย
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      เอกสารอ้างอิง
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      ประเภทแบบ
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      วันที่เอกสาร
                    </th>

                    <th className="text-center" style={{ width: "10%" }}>
                      ยอดเงินรวม
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      ยอดหักภาษี
                    </th>
                    <th className="text-center" style={{ width: "1%" }}>
                      แก้ไข
                    </th>
                    <th
                      className="text-center"
                      style={{ width: "1%" }}
                      hidden={
                        window.location.pathname === "/payment-voucher" ||
                          window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                    >
                      พิมพ์
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {filteredItems.length > 0 ? (
                    currentItems.map((data, index) => (
                      <tr
                        key={data.WTAX_Id || index + 1}
                        onClick={() => onRowSelected(data, index)}
                        style={getDataTableRowStyle(
                          index,
                          selectedRowIndex,
                          null,
                          data,
                          'WTAX_Id'
                        )}
                      >
                        <td className="text-center">
                          {index + 1}
                        </td>
                        <td className="text-center">{data.WTAX_No}</td>
                        <td className=""> {data.AP_Name || "-"}</td>
                        <td className="text-center">{data.Ref_Doc || "-"}</td>
                        <td className="text-center">
                          {Type(data.WTAX_Type) || "-"}
                        </td>
                        <td className="text-center">
                          {getIssueDateDisplay(data)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(data?.WTAX_Total)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(data?.WTAX_Total_Tax)}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm"
                            onClick={() => update(data.WTAX_No)}
                          >
                            <i
                              className="fa fa-edit"
                              style={{ color: "rgb(239, 108, 0)" }}
                            />
                          </button>
                        </td>
                        <td className="text-center">
                          <>
                            <button
                              className="btn btn-link btn-sm px-3"
                              onClick={() => {
                                setOptimisticPrinted((prev) => {
                                  const s = new Set(prev);
                                  s.add(data.WTAX_Id);
                                  return s;
                                });

                                (async () => {
                                  try {
                                    await getReport("TAX", data.WTAX_Id);
                                  } catch (e) {
                                    console.error(e);
                                  } finally {
                                    if (typeof onPageUpdate === 'function') await onPageUpdate();
                                  }
                                })();
                              }}
                            >
                              {(() => {
                                const alreadyPrinted = String(data.Printed_Status || "").toUpperCase() === 'Y';
                                const isPrinted = alreadyPrinted || optimisticPrinted.has(data.WTAX_Id);
                                return (
                                  <i
                                    className="fa fa-print"
                                    style={{ fontSize: "16px", color: isPrinted ? '#13A10E' : 'rgb(13,110,253)' }}
                                  ></i>
                                );
                              })()}
                            </button>
                          </>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination & Items per page selector */}
            <div className="bg-white mt-2" style={{ padding: '8px 0' }}>
              <div className="row m-0">
                <div className="col-12 d-flex justify-content-between align-items-center flex-wrap py-2">
                  <div className="d-flex align-items-center flex-wrap">
                    <span className="me-2">แสดง:</span>
                    <select
                      className="form-select me-2"
                      style={{ width: 'auto', minWidth: '70px' }}
                      value={itemsPerPage}
                      onChange={(e) => {
                        const newItemsPerPage = parseInt(e.target.value);
                        setItemsPerPage(newItemsPerPage);
                        localStorage.setItem('itemsPerPageDropdown', newItemsPerPage);
                        setCurrentPage(1);
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    <span>รายการต่อหน้า | แสดง {indexOfFirstItem + 1} ถึง {Math.min(indexOfLastItem, filteredItems.length)} จาก {filteredItems.length} รายการ</span>
                  </div>
                  <div className="d-flex align-items-center flex-wrap">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      itemsPerPage={itemsPerPage}
                      dataMasterList={filteredItems}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
                <div className="text-muted" style={{ fontSize: "12px" }}>
                  {getDataTableKeyboardInstructions(false, true)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
